import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ErrorLogout from "../../../helpers/ErrorLogout";
import Chart from "react-apexcharts";
import ReactApexChart from "react-apexcharts";
import { getDashboard } from "../../../api/AdminRequest";
import { Button, Spin } from "antd";

function Dashboard() {

  const [loader, setLoader] = useState(false);
  const [surveyStatus, setSurveyStatus] = useState(null);
  const [bidStatus, setBidStatus] = useState(null);
  const [surveyCount, setSurveyCount] = useState(null);
  const [bidCount, setBidCount] = useState(null);
  const [assetStatusName, setAssetStatusName] = useState([]);
  const [assetStatusCount, setAssetStatusCount] = useState([]);
  const [bidAuditResult, setBidAuditResult] = useState([]);
  // console.log(bidAuditResult);

  const [donut, setDonut] = useState({
    options: {
      labels: [],
      plotOptions: {
        pie: {
          donut: {
            size: "70%",
          },
        },
      },
      stroke: {
        show: true,
        width: 6,
        colors: ["#ffffff"],
        lineCap: "round",
      },
      legend: {
        position: "bottom",
      },
      dataLabels: {
        enabled: true,
      },
    },
    series: [],
  });

  useEffect(() => {
    setDonut((prev) => ({
      ...prev,
      options: {
        ...prev.options,
        labels: assetStatusName,
      },
      series: assetStatusCount,
    }));
  }, [assetStatusName, assetStatusCount]);

  useEffect(() => {
    const dashboardCall = async () => {
      try {
        setLoader(true);
        const { data } = await getDashboard();
        // console.log("hdsklfh", data);

        if (data?.success) {
          setSurveyStatus(data?.surveyStatusCountResult || null);
          setBidStatus(data?.bidStatusCountResult || null);
          setSurveyCount(data?.totalSurveyCount || null);
          setBidCount(data?.totalBidCount || null);
          setAssetStatusName(data?.BidSubCategoryName || null);
          setAssetStatusCount(data?.BidSubCategoryCount || null);
          setBidAuditResult(data?.bidAuditResult || null);
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
        console.log(error.message);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    dashboardCall();
  }, []);

  const [bidAuditState, setBidAuditState] = useState({
    series: [
      // Initial state with example data
      {
        name: "2023",
        data: [28, 29, 33, 36, 32, 32, 33, 33, 33, 33, 33, 33],
      },
      {
        name: "2024",
        data: [12, 11, 14, 18, 17, 13, 13, 23, 13, 31, 18, 13],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        dropShadow: {
          enabled: true,
          color: "#000",
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2,
        },
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      colors: ["#77B6EA", "#545454"], // Placeholder colors
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: "smooth",
      },
      grid: {
        borderColor: "#E7E7E7",
        row: {
          colors: ["#F3F3F3", "transparent"],
          opacity: 0.5,
        },
      },
      markers: {
        size: 1,
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        title: {
          text: "Month",
        },
      },
      yaxis: {
        title: {
          text: "Bid Count",
        },
        min: 0,
        max: 40,
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        floating: true,
        offsetY: -25,
        offsetX: -5,
      },
    },
  });

  // console.log(bidAuditState);

  useEffect(() => {
    const transformData = (results) => {
      const years = [...new Set(results.map((result) => result.year))];
      const months = 12;
      return years.map((year) => {
        const data = Array(months).fill(0);
        results.forEach((result) => {
          if (result.year === year) {
            data[result.month - 1] = result.count;
          }
        });
        return {
          name: year.toString(),
          data: data,
        };
      });
    };

    const generateColors = (num) => {
      const colors = [];
      const baseColors = [
        "#00E396",
        "#1D5707",
        "#C0DCB2",
        "#09A580",
        "#64A44E",
        "#00E396",
        "#7CFC00",
      ];
      for (let i = 0; i < num; i++) {
        colors.push(baseColors[i % baseColors.length]);
      }
      return colors;
    };
    // Generate colors for the number of years
    const years = [...new Set(bidAuditResult.map((result) => result.year))];
    const updatedColors = generateColors(years.length);
    // Update state with the transformed data and new colors
    const updatedSeries = transformData(bidAuditResult);
    setBidAuditState((prevState) => ({
      ...prevState,
      series: updatedSeries,
      options: {
        ...prevState.options,
        colors: updatedColors, // Set colors dynamically
      },
    }));
  }, [bidAuditResult]);

  return (
    <Spin spinning={loader}>
      <div className="flex mt-2 justify-end">
      </div>
      <div className="bg-blue-900 rounded-lg w-full min-h-[9rem] mt-4 flex flex-col md:flex-row justify-between overflow-hidden">
        <div className="text-white flex p-6">
          <div className="p-3">
            <p className="">Total Surveys</p>
            <p className="font-semibold text-2xl mt-2">{surveyCount}</p>
          </div>
          <span className="w-[1px] h-20 my-auto bg-blue-700/50"></span>
          <div className="px-3 pt-2  flex items-center">
            <div className="">
              <p className="text-sm mb-2  flex justify-start">Assigned</p>
              <p className="text-sm mb-2 flex justify-start">Accepted</p>
              <p className="text-sm mb-2 flex justify-start">Rejected</p>
              <p className="text-sm mb-2 flex justify-start">Ongoing</p>
              <p className="text-sm mb-2 flex justify-start">Completed</p>
            </div>
            <div className="">
              <p className="font-semibold text-sm mb-2 ml-4">
                {surveyStatus?.pending || 0}
              </p>
              <p className="font-semibold text-sm mb-2 ml-4">
                {surveyStatus?.accepted || 0}
              </p>
              <p className="font-semibold text-sm mb-2 ml-4">
                {surveyStatus?.rejected || 0}
              </p>
              <p className="font-semibold text-sm mb-2 ml-4">
                {surveyStatus?.ongoing || 0}
              </p>
              <p className="font-semibold text-sm mb-2 ml-4">
                {surveyStatus?.completed || 0}
              </p>
            </div>
          </div>
        </div>
        <span className="hidden md:block w-[1px] h-28 bg-slate-50 mt-3"></span>
        <div className="text-white flex p-6">
          <div className="p-3">
            <p className="">Total Bid</p>
            <p className="font-semibold text-2xl mt-2">{bidCount}</p>
          </div>
          <span className="w-[1px] h-20 my-auto bg-blue-700/50"></span>
          <div className="px-3 flex items-center">
            <div className="">
              <p className="text-sm mb-2 flex justify-start">Approved</p>
              <p className="text-sm mb-2 flex justify-start">Rejected</p>
              <p className="text-sm mb-2 flex justify-start">Pending</p>
            </div>
            <div className="">
              <p className="font-semibold text-sm mb-2 ml-4">
                {bidStatus?.approved || 0}
              </p>
              <p className="font-semibold text-sm mb-2 ml-4">
                {bidStatus?.rejected || 0}
              </p>
              <p className="font-semibold text-sm mb-2 ml-4">
                {bidStatus?.pending || 0}
              </p>
            </div>
          </div>
        </div>
        {/* <div className="text-white flex p-6">
          <span className="w-[1px] h-28  bg-slate-50"></span>

          <div className="p-3">
            <p className="">Total Surveys</p>
            <p className="font-semibold text-xl mt-2">25</p>
          </div>
        </div> */}

        <div></div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6 pb-6">
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
          <h5 className="card-title mb-6 font-bold text-gray-800 text-lg">Bid-Sub Category Wise Graph</h5>
          <div className="flex justify-center">
            <Chart
              options={donut.options}
              series={donut.series}
              type="donut"
              width="100%"
              height="380"
            />
          </div>
        </div>

        <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
          <h5 className="card-title mb-6 font-bold text-gray-800 text-lg">Bid Audit Count</h5>
          <ReactApexChart
            options={bidAuditState.options}
            series={bidAuditState.series}
            type="line"
            width="100%"
            height="380"
          />
        </div>
      </div>
    </Spin>
  );
}

export default Dashboard;
